import axios from "axios";
import tokenManager from "../../utils/tokenManager";

/**
 * Decodifica o payload de um JWT sem verificar a assinatura
 * @param {string} token - Token JWT
 * @returns {object} Payload decodificado ou objeto vazio em caso de erro
 */
function parseJwt(token) {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    return {};
  }
}

const EXPECTED_APPLICATION = 'myplatMaker';

const axiosBase = axios.create({
  mode: "cors",
  baseURL: process.env.REACT_APP_API_URL
});

// Interceptor para adicionar token e validar application antes de cada requisição
axiosBase.interceptors.request.use(
  (config) => {
    // Lê o token atual do tokenManager antes de cada requisição
    const token = tokenManager.getToken();

    if (token) {
      // Valida se o token pertence à aplicação myplatMaker
      const payload = parseJwt(token);
      const application = payload?.application || payload?.applicaton; // typo histórico coberto

      if (application && application !== EXPECTED_APPLICATION) {
        // Dispara evento global para que a UI exiba um aviso e redirecione para o login
        window.dispatchEvent(
          new CustomEvent('invalid-application-token', {
            detail: { application, expected: EXPECTED_APPLICATION }
          })
        );

        // Cancela a requisição — axios.isCancel(error) retornará true nos catch()
        return Promise.reject(
          new axios.Cancel(`Token inválido para esta aplicação (${application}). Esperado: ${EXPECTED_APPLICATION}.`)
        );
      }

      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosBase;